export default __webpack_public_path__ + "static/media/profile_tip_profile_picture.1e034179.svg";